import React, { useEffect, useRef, useState } from 'react'
import { Platform, TextInput, View } from 'react-native'
import { theme, helpers } from '@linqpal/common-frontend'
import { KeyboardType } from '@linqpal/models/src/dictionaries'

const { composeStyle } = helpers

const { commonColors } = theme

const OTP_SIZE = 6

function usePrevious(value) {
  const ref = useRef(value)
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

export default ({
  otp = '',
  onChange,
  otpSize = OTP_SIZE,
  invalid = false,
  disabled = false,
  testID = 'six-digit-code-component',
}) => {
  const [value, setValue] = useState('')
  const [refs, setRef] = useState([])
  const [focused, setFocused] = useState(0)

  useEffect(() => {
    setValue(otp)
  }, [otp])

  useEffect(() => {
    if (onChange) {
      onChange(value)
    }
    if (refs[value.length]) {
      refs[value.length].focus()
    } else if (refs[value.length - 1]) {
      value.length < 6 && refs[value.length - 1].blur()
    }
  }, [value])

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-between',
      }}
      testID={testID}
    >
      {Array(otpSize || OTP_SIZE)
        .fill()
        .map((_, i) => {
          return (
            <TextInput
              testID={`otp_${i}`}
              key={i}
              ref={(ref) =>
                setRef((refs) => {
                  refs[i] = ref
                  return refs
                })
              }
              value={value[i] || ''}
              editable={i === value.length}
              blurOnSubmit={false}
              returnKeyType={i === 5 ? 'done' : 'next'}
              autoComplete={i === 0 ? 'password' : 'off'}
              keyboardType={KeyboardType.NumberPad}
              disabled={disabled}
              secureTextEntry
              onFocus={() => setFocused(i)}
              onKeyPress={(e) => {
                if (e.keyCode === 8 || e.keyCode === 46) {
                  setValue(value.substr(0, value.length - 1))
                }
              }}
              {...Platform.select({
                web: {
                  onClick: () => {
                    if (refs[value.length]) {
                      refs[value.length].focus()
                    } else if (value.length >= otpSize || OTP_SIZE) {
                      setValue(value.substr(0, 5))
                    }
                  },
                },
              })}
              style={composeStyle(
                {
                  borderRadius: 6,
                  padding: 8,
                  textAlign: 'center',
                  width: 40,
                  border: invalid
                    ? `1px solid ${commonColors.accent}`
                    : focused === i
                    ? `1px solid ${commonColors.accentText}`
                    : '1px solid #E6EBEE',
                  fontSize: 20,
                  fontWeight: '500',
                  color: commonColors.primary,
                },
                Platform.select({ web: { outline: 'none' } }),
              )}
              onChangeText={(text) => {
                setValue(value.substring(0, i) + text)
              }}
            />
          )
        })}
    </View>
  )
}
